<template>
  <div id="header">
    <div
      id="kt_header_mobile"
      class="kt-header-mobile kt-header-mobile--fixed"
      style="height:60px;"
    >
      <div class="kt-header-mobile__logo">
        <a href="/">
          <img alt="Logo" src="static/assets/media/logos/logo-text-light.png">
        </a>
      </div>
      <div class="kt-header-mobile__toolbar">
        <button
          class="kt-header-mobile__toggler kt-header-mobile__toggler"
          id="kt_aside_mobile_toggler"
        >
          <span></span>
        </button>
        <div class="kt-header__topbar-item kt-header__topbar-item--user">
            <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="0px,0px">
              <div class="kt-header__topbar-user">
                <button class="kt-header-mobile__topbar-toggler" id="kt_header_mobile_topbar_toggler">
                  <i class="flaticon-more"></i>
                </button>
              </div>
            </div>
            <div
              class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl"
            >
              <div
                class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
                style="background-image: url(static/assets/img/misc/bg-1.jpg)"
              >
                <div class="kt-user-card__avatar">
                  <img alt="Pic" src="static/assets/img/users/default.jpg">
                </div>
                <div class="kt-user-card__name">{{ $store.state.user.fname }}
                  &nbsp;{{ $store.state.user.lname }}</div>
              </div>
              <div class="kt-notification">
                <a href="javascript:void(0)" class="kt-notification__item">
                  <div class="kt-notification__item-icon">
                    <i class="flaticon2-calendar-3 kt-font-success"></i>
                  </div>
                  <div class="kt-notification__item-details" href="/profile">
                    <div class="kt-notification__item-title kt-font-bold">My {{ $store.state.user.fname }}&nbsp;{{ $store.state.user.lname }}</div>
                    <div class="kt-notification__item-time">  ข้อมูลผู้ใช้งานระบบ</div>
                  </div>
                </a>
                <div class="kt-notification__custom kt-space-between">
                  <span></span>
                   <a
                    href="javascript:void(0)"
                    target="_blank"
                    class="btn btn-label btn-label-brand btn-sm btn-bold"
                    @click="logout()"
                  >ออกจากระบบ</a>
                  <!--<a href="demo1/custom/user/login-v2.html" target="_blank" class="btn btn-clean btn-sm btn-bold">ออกจากระบบ</a>-->
                </div>
                
                
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>


<script>
import api from '../../service/service.js'
export default {
  methods: {
    logout () {
      api.Logout()
      this.$router.push({name: 'Login'})
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/header.vue